import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import MotorReservaRoomsAPI from '../../api/motorReservaRooms';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getRecords({ commit }) {
    commit(types.SET_MOTOR_RESERVA_ROOMS_UI_FLAG, { isFetching: true });
    try {
      const response = await MotorReservaRoomsAPI.get();
      commit(types.SET_MOTOR_RESERVA_ROOMS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MOTOR_RESERVA_ROOMS_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createRecord({ commit }, data) {
    commit(types.SET_MOTOR_RESERVA_ROOMS_UI_FLAG, { isCreating: true });
    try {
      const response = await MotorReservaRoomsAPI.create(data);
      commit(types.ADD_MOTOR_RESERVA_ROOM, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_MOTOR_RESERVA_ROOMS_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateRecord({ commit }, { id, ...updateObj }) {
    commit(types.SET_MOTOR_RESERVA_ROOMS_UI_FLAG, { isUpdating: true });
    try {
      const response = await MotorReservaRoomsAPI.update(id, updateObj);
      commit(types.EDIT_MOTOR_RESERVA_ROOM, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MOTOR_RESERVA_ROOMS_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteRecord({ commit }, id) {
    commit(types.SET_MOTOR_RESERVA_ROOMS_UI_FLAG, { isDeleting: true });
    try {
      await MotorReservaRoomsAPI.delete(id);
      commit(types.DELETE_MOTOR_RESERVA_ROOM, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MOTOR_RESERVA_ROOMS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_MOTOR_RESERVA_ROOMS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_MOTOR_RESERVA_ROOMS]: MutationHelpers.set,
  [types.ADD_MOTOR_RESERVA_ROOM]: MutationHelpers.create,
  [types.EDIT_MOTOR_RESERVA_ROOM]: MutationHelpers.update,
  [types.DELETE_MOTOR_RESERVA_ROOM]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
